import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

export const _LandingFooterRoot = styled("section")<{
  $bg?: {
    desktop?: string;
    mobile?: string;
  };
}>(({ $bg }) => {
  const { desktop: desktopBg, mobile: mobileBg } = $bg || {};
  return css`
    // background-color: #ffffff;
    color: #000000;
    min-height: 335px;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 99px 0 64px;
    text-align: center;
    position: relative;

    background-image: url(${desktopBg});
    background-size: 100% auto;
    background-repeat: no-repeat;

    @media ${responsiveMap.maxLg} {
      background-image: url(${mobileBg || desktopBg});
    }

    @media ${responsiveMap.mobile} {
      padding: 40px 38px 82px;
    }

    .logo-link {
      margin-bottom: 55px;
      @media ${responsiveMap.mobile} {
        margin-bottom: 48px;
      }
    }

    .landing-footer-title {
      margin-bottom: 10px;
      text-align: center;
      @media ${responsiveMap.mobile} {
        margin-bottom: 16px;
      }
    }
    .landing-footer-hashtag {
      margin-bottom: 37px;
      text-align: center;
      @media ${responsiveMap.mobile} {
        margin-bottom: 16px;
      }
    }

    .landing-footer-social-label {
      text-align: center;
    }
    .landing-footer-bottom-text {
      text-align: center;
      margin: 35px auto 0;
      max-width: 680px;
    }
  `;
});
